/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Go_To_SectionInputs */

const en_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to section`)
};

const de_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Abschnitt`)
};

const fr_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à la section`)
};

const es_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a la sección`)
};

const it_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai alla sezione`)
};

const nl_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ga naar sectie`)
};

const pl_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do sekcji`)
};

const fi_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry osioon`)
};

const da_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå til afsnit`)
};

const sv_ats_tip_go_to_section = /** @type {(inputs: Ats_Tip_Go_To_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå till avsnitt`)
};

/**
* | output |
* | --- |
* | "Go to section" |
*
* @param {Ats_Tip_Go_To_SectionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_go_to_section = /** @type {((inputs?: Ats_Tip_Go_To_SectionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Go_To_SectionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_go_to_section(inputs)
	if (locale === "fr") return fr_ats_tip_go_to_section(inputs)
	if (locale === "es") return es_ats_tip_go_to_section(inputs)
	if (locale === "it") return it_ats_tip_go_to_section(inputs)
	if (locale === "nl") return nl_ats_tip_go_to_section(inputs)
	if (locale === "pl") return pl_ats_tip_go_to_section(inputs)
	if (locale === "fi") return fi_ats_tip_go_to_section(inputs)
	if (locale === "da") return da_ats_tip_go_to_section(inputs)
	if (locale === "sv") return sv_ats_tip_go_to_section(inputs)
	return en_ats_tip_go_to_section(inputs)
});